import React, { useState } from 'react';
import cl from './TransportTemplate.module.css';
import { useAppSelector } from "../../../../../../app/store";
import { selectCurrentUser } from "../../../../../../features/authentication/authenticationSliceSelectors";
import { useGridCellHandleClick } from "../../../../../../components/ui/Grid/Telerik/hooks/useGridCellHandleClick";
import { useTranslation } from "react-i18next";
import { getUserRole } from "../../../../../../helpers/user";
import { UserRole } from "../../../../../../app/enums/UserRole";
import EditTransportDialog from "../../../actions/EditTransport/EditTransportDialog";
import Icon from "../../../../../../assets/icon/Icon";

const TransportTemplate = (props: any) => {
    const user = useAppSelector(selectCurrentUser);
    const { handleClick } = useGridCellHandleClick(props.dataItem);
    const { t } = useTranslation();
    const [isDialogShown, setIsDialogShown] = useState<boolean>(false);

    let sId = props.dataItem.sId !== undefined && props.dataItem.sId !== null
        ? props.dataItem.sId
        : '';
    let rId = props.dataItem.rId !== undefined && props.dataItem.rId !== null
        ? props.dataItem.rId
        : '';
    let val = props.dataItem[props.field] !== undefined && props.dataItem[props.field] !== null
        ? props.dataItem[props.field]
        : '';
    let isArchive = props.dataItem.isArchive !== null && props.dataItem.isArchive !== undefined
        ? Boolean(props.dataItem.isArchive)
        : false;

    let noGps = props.dataItem["noGps"] !== null && props.dataItem["noGps"] !== undefined
        ? Boolean(props.dataItem["noGps"])
        : false;

    let transportHasError = props.dataItem["transportHasError"] !== null
        && props.dataItem["transportHasError"] !== undefined
        ? Boolean(props.dataItem["transportHasError"])
        : false;


    if (!sId || sId === '' || isArchive || !user || (getUserRole(user) === UserRole.Client)) {
        return (
            <td {...props.tdProps}
                colSpan={1}
                onClick={handleClick}>
                <span className={'default-left-cell default-overflow-cell'}>
                    {val}
                </span>
            </td>
        )
    }

    return (
        <td {...props.tdProps}
            colSpan={1}>
            <EditTransportDialog id={rId}
                sId={sId}
                show={isDialogShown}
                setShow={setIsDialogShown} />

            <span onClick={handleClick} className={'default-left-cell default-overflow-cell grid-prevent-selection'}>
                <>
                    <Icon icon={"faPen"}
                        className={`${cl.icon} ${val && val !== '' ? cl.iconWithValue : ''} shipment-grid-edit-transport-btn grid-prevent-selection`}
                        onClick={(ev) => {
                            ev.stopPropagation();

                            setIsDialogShown(prev => !prev);
                        }} />

                    {transportHasError && (
                        <span
                            className={`grid-prevent-selection ${cl.errorIcon}`}
                            title={t("shipment.grid.transport-error-tooltip")}
                            onClick={(ev) => ev.stopPropagation()}
                        >
                            &#9888;
                        </span>
                    )}

                    {val && val !== ''
                        ? <span className={`grid-prevent-selection ${cl.text}`}
                            title={
                                [
                                    transportHasError ? t("shipment.grid.transport-error-tooltip") : null,
                                    noGps ? t("shipment.grid.no-gps-tooltip") : null
                                ]
                                    .filter(Boolean)
                                    .join(". ") || undefined
                            }
                            style={noGps ? { color: 'red' } : undefined}
                            onClick={(ev) => {
                                ev.stopPropagation();

                                setIsDialogShown(prev => !prev);
                            }}>
                            {val}
                        </span>
                        : <span className={`grid-prevent-selection ${cl.addText}`}
                            onClick={(ev) => {
                                ev.stopPropagation();

                                setIsDialogShown(prev => !prev);
                            }}>
                            {t("shipment.grid.add-transport")}
                        </span>
                    }
                </>
            </span>
        </td>
    );
};

export default TransportTemplate;
